<template>
    <div>
        <el-form label-width="160px">
            <div class="title">
                {{ $t('operation.taskManage') }}
                <el-button size="small" class="sys-btn-default" @click="goEdit" style="float: right;"
                    v-permission="taskListEdit">{{
                    $t('common.edit')
                }}</el-button>
            </div>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('operation.task.taskName') + '：'">
                        <span class="normal-label">{{ dataForm.taskName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('operation.task.patrolServer') + '：'">
                        <span class="normal-label">{{ dataForm.userName }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item :label="$t('operation.task.workingTime') + '：'">
                <span>{{ dataForm.timePeriods }}</span>
            </el-form-item>

            <el-form-item :label="$t('operation.task.interval') + '：'">
                <span class="normal-label">{{ dataForm.interval }} {{ $t('operation.task.seconds') }}</span>
            </el-form-item>

            <div class="title sys-split-line"> {{ $t('operation.task.channels') }}</div>

            <ChannelTree ref="channelTreeRef" :setDisabledAttr="true"></ChannelTree>

        </el-form>
    </div>
</template>

<script>
import ChannelTree from './channelTree.vue'
import Cookies from 'js-cookie'
export default {
    props: {
        dataForm: {
            type: Object,
            default: {}
        },
        timePeriods: []
    },
    watch: {
        dataForm(newVal, oldVal) {
            this.dataForm = newVal;
        }
    },
    components: {
        ChannelTree
    },
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
        }
    },
    created() {
        this.$nextTick(() => {
            this.$refs.channelTreeRef.initDataList(1, `${this.$Api.captureTaskDeviceTree}/${this.monitorId}/${this.dataForm.taskId}/0`, this.dataForm.cameraConfigList);
        })
    },
    methods: {
        goEdit() {
            this.$emit('updateType');
        },
    }
}
</script>